import { appCode } from '@/common/consts';


// use this approach to split the code of a component, and bundle it as a separate chunk that is loaded lazily
const TwitterConnector = () => import('@/components/twitterConnector/TwitterConnector');
const FacebookConnector = () => import('@/components/facebookConnector/FacebookConnector');
const InstagramConnector = () => import('@/components/instagramConnector/InstagramConnector');



export const routerPaths = {
  TwitterConnector: `/${appCode}/twitterConnector`,
  InstagramConnector: `/${appCode}/instagramConnector`,
  FacebookConnector: `/${appCode}/facebookConnector`,
  TwitterConnectorAuth: ':oAuthToken/:oAuthVerifier',
  InstagramConnectorAuth: ':accessToken/:userID',
  TwitterConnectorError: 'error',
};
export default [
  {
    path: routerPaths.TwitterConnector,
    name: `${appCode}:twitterConnector`,
    meta: { mainRoute: routerPaths.TwitterConnector },
    children: [
      {
        path: routerPaths.TwitterConnectorAuth,
        name: `${appCode}:twitterConnector.connect`,
        meta: { mainRoute: routerPaths.TwitterConnector },
        component: TwitterConnector,
      },
      {
        path: routerPaths.TwitterConnectorError,
        name: `${appCode}:twitterConnector.error`,
        meta: { mainRoute: routerPaths.TwitterConnector },
        component: TwitterConnector,
      }],
    components: { [appCode]: TwitterConnector },
  },
  {
    path: routerPaths.FacebookConnector,
    name: `${appCode}:facebookConnector`,
    components: { [appCode]: FacebookConnector },
  },
  {
    path: routerPaths.InstagramConnector,
    name: `${appCode}:instagramConnector`,
    components: { [appCode]: InstagramConnector },
    meta: { mainRoute: routerPaths.InstagramConnector },
    children: [
      {
        path: routerPaths.InstagramConnectorAuth,
        name: `${appCode}:instagram.connect`,
        meta: { mainRoute: routerPaths.InstagramConnector },
        component: InstagramConnector,
      }],
  },
  {
    path: '/sm/',
    name: 'default',
    redirect: { path: `/${appCode}/twitterConnector` },
  },
];

